module.exports = __webpack_public_path__ + "static/img/news_header.25cc785.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yearContent/news_header.jpg
// module id = 3lKg
// module chunks = 2